import { useQuery } from 'react-query';
import reactQueryKeys from '../reactQueryKeys';
import { IMetadata } from '../../lib/interfaces/Metadata';
import { getMetadata } from '../../api/apiRequests/metadata';

const useGetMetadataQuery = (options = {}) => {
	const metadataCacheKey = 1;
	const metadataLsKey = `metadata_${metadataCacheKey}`;
	const metadataFromLS = localStorage.getItem(metadataLsKey);
	const initialData = metadataFromLS ? JSON.parse(metadataFromLS) : null;
	return useQuery<IMetadata, Error>(
		[reactQueryKeys.metadata],
		() => getMetadata(),
		{
			onError: (error) => {
				console.error('error: ', error);
			},
			onSuccess(data) {
				localStorage.setItem(metadataLsKey, JSON.stringify(data));
			},
			placeholderData: initialData,
			...options,
		},
	);
};

export default useGetMetadataQuery;
